module.exports = __webpack_public_path__ + "a61ff49262e5a52b5f0707b0302b3225.png";